import React, { useEffect, useRef, lazy } from 'react';
const images = [{
  url: 'https://cdn.magicpatterns.com/uploads/urbw6pWaoxgreoroUwT61g/b01.png',
  alt: 'Corte artístico con diseño leopardo verde neón'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/igvU8cW83t6jKwuczgqN5M/b02.png',
  alt: 'Corte con colores arcoíris y diseño estrella'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/dPKUqGQXHkVvtCXwQbauUm/b03.png',
  alt: 'Corte platino con diseño de letras de colores'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/gJT1wky7Akmjo4BS59LkPM/b04.png',
  alt: 'Corte infantil con color rosa y fade'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/cvv6C2zBhNpjzibFT4PqSp/b05.png',
  alt: 'Corte con color lila y verde menta'
}];
// Duplicate for seamless infinite loop
const row1 = [...images, ...images, ...images];
const row2 = [...images.slice(2), ...images.slice(0, 2), ...images.slice(2), ...images.slice(0, 2), ...images.slice(2), ...images.slice(0, 2)];
function useScrollReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function GallerySection() {
  const headerRef = useScrollReveal(0);
  return <section className="w-full py-20 sm:py-28 overflow-hidden" style={{
    backgroundColor: '#000000'
  }} aria-label="Galería de cortes" data-id="element-123">
      {/* Header */}
      <div ref={headerRef} className="max-w-6xl mx-auto px-4 sm:px-6 mb-14 text-center" data-id="element-124">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-125">
          <div style={{
          width: '40px',
          height: '1px',
          background: '#C9A84C'
        }} data-id="element-126" />
          <span className="section-label" data-id="element-127">Nuestro Trabajo</span>
          <div style={{
          width: '40px',
          height: '1px',
          background: '#C9A84C'
        }} data-id="element-128" />
        </div>
        <h2 style={{
        fontFamily: 'var(--font-heading)',
        fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
        fontWeight: 700,
        color: '#F5F5F5',
        lineHeight: 1.2,
        marginBottom: '1rem'
      }} data-id="element-129">
          El Arte Habla{' '}
          <span style={{
          color: '#C9A84C',
          fontStyle: 'italic'
        }} data-id="element-130">
            Por Sí Solo
          </span>
        </h2>
        <p style={{
        fontFamily: 'var(--font-body)',
        fontSize: '1.05rem',
        color: '#888',
        lineHeight: 1.7,
        maxWidth: '500px',
        margin: '0 auto'
      }} data-id="element-131">
          Cada corte es una obra. Cada cliente, un lienzo. Esto es lo que sale
          de nuestra silla.
        </p>
      </div>

      {/* Row 1 — scrolls left */}
      <div className="relative mb-4" style={{
      maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)'
    }} data-id="element-132">
        <div className="flex gap-4" style={{
        animation: 'marquee-left 40s linear infinite',
        width: 'max-content'
      }} data-id="element-133">
          {row1.map((img, i) => <GalleryCard key={`r1-${i}`} url={img.url} alt={img.alt} data-id="element-134" />)}
        </div>
      </div>

      {/* Row 2 — scrolls right */}
      <div className="relative" style={{
      maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)'
    }} data-id="element-135">
        <div className="flex gap-4" style={{
        animation: 'marquee-right 45s linear infinite',
        width: 'max-content'
      }} data-id="element-136">
          {row2.map((img, i) => <GalleryCard key={`r2-${i}`} url={img.url} alt={img.alt} data-id="element-137" />)}
        </div>
      </div>

      {/* Bottom label */}
      <div className="text-center mt-14" data-id="element-138">
        <a href="#location" className="btn-gold inline-flex items-center gap-3 px-8 py-4 text-base rounded-sm" data-id="element-139">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-140">
            <circle cx="12" cy="12" r="10" data-id="element-141" />
            <circle cx="12" cy="12" r="3" data-id="element-142" />
          </svg>
          Quiero Mi Corte Así
        </a>
      </div>
    </section>;
}
function GalleryCard({
  url,
  alt
}: {
  url: string;
  alt: string;
}) {
  return <div className="flex-shrink-0 overflow-hidden rounded-sm" style={{
    width: '220px',
    height: '280px',
    border: '1px solid rgba(201,168,76,0.15)',
    position: 'relative'
  }} data-id="element-143">
      <img src={url} alt={alt} loading="lazy" style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'top center',
      display: 'block',
      transition: 'transform 0.6s ease'
    }} onMouseEnter={e => {
      ;
      (e.currentTarget as HTMLImageElement).style.transform = 'scale(1.06)';
    }} onMouseLeave={e => {
      ;
      (e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';
    }} data-id="element-144" />
      {/* Subtle gold bottom shimmer */}
      <div style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '60px',
      background: 'linear-gradient(to top, rgba(201,168,76,0.12), transparent)',
      pointerEvents: 'none'
    }} aria-hidden="true" data-id="element-145" />
    </div>;
}